import * as tslib_1 from "tslib";
import { ElementRef, ViewContainerRef } from '@angular/core';
import { HeatmapService } from '../../../../services/heatmap.service';
import { LayerService } from '../../../../services/layer.service';
import { HeatmapMode } from '../../../../types';
var HeatmapEditorComponent = /** @class */ (function () {
    function HeatmapEditorComponent(_vcr, layerService, heatmapService) {
        var _this = this;
        this._blurRadius = 0;
        this._heatmapMode = HeatmapMode.Off;
        this.colorProperties = ['symbolColor, outlineColor'];
        this.applyChange = function () {
            return _this.heatmapRenderer;
        };
        this.layerService = layerService;
        this.heatmapService = heatmapService;
    }
    Object.defineProperty(HeatmapEditorComponent.prototype, "canvas", {
        set: function (canvas) {
            if (canvas) {
                this._canvas = canvas;
                this.updateColorRamp();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeatmapEditorComponent.prototype, "uniqueLayerId", {
        get: function () {
            return this._uniqueLayerId;
        },
        set: function (value) {
            this._uniqueLayerId = value;
            if (value) {
                this.esriLayer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeatmapEditorComponent.prototype, "heatmapRenderer", {
        get: function () {
            return this._heatmapRenderer;
        },
        set: function (value) {
            this._heatmapRenderer = value;
            this.bindForm();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeatmapEditorComponent.prototype, "blurRadius", {
        get: function () {
            return this._blurRadius;
        },
        set: function (value) {
            this._blurRadius = value;
            if (value && this.esriLayer) {
                this.heatmapRenderer.blurRadius = this.blurRadius;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeatmapEditorComponent.prototype, "heatmapMode", {
        get: function () {
            return this._heatmapMode;
        },
        set: function (value) {
            this._heatmapMode = value;
        },
        enumerable: true,
        configurable: true
    });
    HeatmapEditorComponent.prototype.bindForm = function () {
        if (this.heatmapRenderer) {
            if (this.heatmapRenderer.type === 'heatmap') {
                var renderer = this.heatmapRenderer;
                this.blurRadius = this.heatmapRenderer.blurRadius;
                this.startColorRamp = "rgb(" + renderer.colorStops.map(function (x) { return x.color; })[1].toRgb().join(', ') + ")";
                this.endColorRamp = "rgb(" + renderer.colorStops.map(function (x) { return x.color; })[2].toRgb().join(', ') + ")";
                this.updateColorRamp();
            }
        }
    };
    HeatmapEditorComponent.prototype.updateColorFromPicker = function (evt, colorProperty) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rgbColor, initColor, rgbaColor;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this[colorProperty] = evt;
                        if (!(this.esriLayer && evt)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.heatmapService.getColorString(evt, false)];
                    case 1:
                        rgbColor = _a.sent();
                        return [4 /*yield*/, this.heatmapService.getColorString(evt, true, true)];
                    case 2:
                        initColor = _a.sent();
                        return [4 /*yield*/, this.heatmapService.getColorString(evt, true)];
                    case 3:
                        rgbaColor = _a.sent();
                        this.heatmapRenderer.colorStops[colorProperty].color.setColor(rgbaColor);
                        if (colorProperty === '1') {
                            this.startColorRamp = rgbColor;
                            this.heatmapRenderer.colorStops[0].color.setColor(initColor);
                        }
                        else {
                            this.endColorRamp = rgbColor;
                        }
                        this.updateColorRamp();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HeatmapEditorComponent.prototype.updateColorRamp = function () {
        if (this._canvas) {
            this._canvas.nativeElement.style.background = "linear-gradient(to right, " + this.startColorRamp + " 0%, " + this.endColorRamp + " 100%)";
        }
    };
    HeatmapEditorComponent.prototype.heatmapToggle = function (heatmapMode) {
        this.esriLayer.mapcoreProps.heatmapMode = heatmapMode;
    };
    HeatmapEditorComponent.prototype.onHeatmapModeChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.esriLayer) return [3 /*break*/, 2];
                        this.esriLayer.mapcoreProps.heatmapMode = this.heatmapMode;
                        _a = this;
                        return [4 /*yield*/, this.heatmapService.updateHeatmapLayers(this.esriLayer)];
                    case 1:
                        _a.esriLayer = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    HeatmapEditorComponent.prototype.onPixelIntensityChange = function (e) {
        if (e.detail) {
            this.heatmapRenderer.minPixelIntensity = e.detail.minValue;
            this.heatmapRenderer.maxPixelIntensity = e.detail.maxValue;
        }
    };
    return HeatmapEditorComponent;
}());
export { HeatmapEditorComponent };
